<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3">
  <h2>Repair Record - {{this.repairData?.repairId}}</h2>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">

  <section id="breakdownDetails">

    <div class="w-full flex justify-end mb-4">
      <button *appHasAnyPrivilege="'REPAIR_RECORDS_UPDATE'" class="sm:hidden" nz-button nzType="primary" style="max-width: 120px" (click)="editNavigate()">Edit Details</button>
    </div>


    <nz-card>
      <div>

        <div class="flex justify-between gap-2 flex-col md:flex-row">
          <h5>Breakdown Details</h5>
          <button *appHasAnyPrivilege="'REPAIR_RECORDS_UPDATE'" class="sm:block hidden" nz-button nzType="primary" style="max-width: 120px" (click)="editNavigate()">Edit Details</button>
        </div>

        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div class="sub-section" style="height: 100%">
            <div class="item-row">
              <p class="subject-name">Breakdown Date</p>
              <p class="subject-data">{{ this.repairData?.breakdownDetails.breakdownDate | date:'yyyy-MM-dd' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Repairs Done By</p>
              <p class="subject-data">{{this.repairData?.breakdownDetails.repairDoneBy}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Issue Type</p>
              <p class="subject-data">{{this.repairData?.breakdownDetails.issueType}} </p>
            </div>
            <div class="item-row" *ngIf="this.repairData?.breakdownDetails.issueType.includes('Other')">
              <p class="subject-name">Other Issue</p>
              <p class="subject-data">{{this.repairData?.breakdownDetails.otherIssue}} </p>
            </div>
          </div>

          <div class="sub-section" style="height: 100%">
            <div>
              <p class="subject-name">Notes:</p>
              <p class="subject-data">{{this.repairData?.breakdownDetails.notesBreakdown}}</p>
            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="repairInformation" class="mt-6">
    <nz-card>
      <div>
        <h5>Repair Information</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div class="sub-section" style="height: 100%">
            <div class="item-row" *ngIf="this.repairData.breakdownDetails.repairDoneBy === 'Rental Customer'">
              <p class="subject-name">Replaced Parts</p>
              <div class="flex">
                <p class="subject-data" *ngFor="let part of repairData?.repairInformation?.partsReplacedByCustomer">{{part + ' , ' }}</p>
              </div>
            </div>
            <div class="item-row" *ngIf="repairData?.repairInformation?.otherParts && this.repairData.breakdownDetails.repairDoneBy === 'Rental Customer'">
              <p class="subject-name">Other Parts</p>
              <div class="flex">
                <p class="subject-data">{{repairData?.repairInformation?.otherParts ? repairData?.repairInformation?.otherParts : '-' }}</p>
              </div>
            </div>
            <div class="item-row">
              <p class="subject-name">Repair Start Date</p>
              <p class="subject-data">{{repairData?.repairInformation?.repairStartDate ? (repairData?.repairInformation?.repairStartDate| date:'yyyy-MM-dd') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Projected Repair End Date</p>
              <p class="subject-data">{{repairData?.repairInformation?.repairEndDate ? (repairData?.repairInformation?.repairEndDate| date:'yyyy-MM-dd') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Actual Repair End Date</p>
              <p class="subject-data">{{repairData?.repairInformation?.actualRepairStartDate ? (repairData?.repairInformation?.actualRepairStartDate| date:'yyyy-MM-dd') : '-' }}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Back To Fleet Date</p>
              <p class="subject-data">{{ this.repairData?.repairInformation.backToFleetDate | date:'yyyy-MM-dd' }}</p>
            </div>
            <div>
              <p class="subject-name">Notes:</p>
              <p class="subject-data">{{ this.repairData?.repairInformation.notesInformation}}</p>
            </div>
          </div>

          <div class="sub-section" style="height: 100%">
            <div>
              <p class="subject-name mb-2">Attachments</p>

              <div class="mb-3" *ngFor="let item of this.repairsAttachment">
                <a [href]="item.url" class="flex">
                  <img height="20" width="20" src="assets/img/file.png" alt="file">
                  <p class="pl-3 font medium">{{item.name}}</p>
                </a>
              </div>


            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="paymentDetails" class="mt-6">
    <nz-card>
      <div>
        <h5>Payment Details</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div class="sub-section" style="height: 100%">
            <div class="item-row">
              <p class="subject-name">Payment Done By</p>
              <p class="subject-data">{{ this.repairData?.paymentDetails.paymentDoneBy}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Total Cost</p>
              <p class="subject-data">{{ 'Rs.' + this.repairData?.paymentDetails.totalCost}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Repayment Type</p>
              <p class="subject-data">{{ this.repairData?.paymentDetails.repaymentType}}</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Installments</p>
              <p class="subject-data" *ngIf="this.repairData?.paymentDetails.installments === 'YES'">Yes</p>
              <p class="subject-data" *ngIf="this.repairData?.paymentDetails.installments === 'NO'">No</p>
            </div>
            <div class="item-row">
              <p class="subject-name">Installment Period</p>
              <p class="subject-data">{{ this.repairData?.paymentDetails.installmentPeriod}}</p>
            </div>
            <div>
              <p class="subject-name">Notes:</p>
              <p class="subject-data">{{ this.repairData?.paymentDetails.notesPayments}}</p>
            </div>
          </div>

          <div class="sub-section" style="height: 100%">
            <div>
              <p class="subject-name mb-2">Attachments</p>

              <div class="mb-3" *ngFor="let item of this.paymentAttachments">
                <a [href]="item.url" class="flex">
                  <img height="20" width="20" src="assets/img/file.png" alt="file">
                  <p class="pl-3 font medium">{{item.name}}</p>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>
</div>

<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
</div>
